/* prodnamo : produits digitaux = max 1 exemplaire par produit */
(function () {
  if (window.__pnMax1) return;
  window.__pnMax1 = true;
  var inCart = new Set();
  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { inCart = new Set(c.items.map(function (i) { return String(i.id); })); })
      .catch(function () {});
  }
  refresh();
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 40); });
    }
    return p;
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], .product-form__submit');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]') || document.querySelector('product-form form');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl) return;
    if (inCart.has(String(idEl.value))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.open) cd.open();
    }
  }, true);
})();
/* prodnamo : carrousels glissables a la souris (ordi).
   Detection automatique : n'importe quel conteneur qui defile horizontalement
   sous la souris (carrousels Dawn, sections custom...). Au doigt, le
   navigateur le fait deja nativement. */
(function () {
  if (window.__pnDragSlider) return;
  window.__pnDragSlider = true;

  var SKIP = 'input, textarea, select, iframe, [contenteditable], .beat-player-bar, .viz-panel, [data-pn-own-drag]';

  // remonte depuis la cible jusqu'au premier element qui scrolle en X
  function scroller(node) {
    if (!node || !node.closest || node.closest(SKIP)) return null;
    for (var el = node; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      if (el._pnX === false) continue;
      if (el.scrollWidth > el.clientWidth + 2) {
        var ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return el;
      }
    }
    return null;
  }

  var drag = null, justDragged = false, hoverEl = null;

  // curseur "main" au survol d'un carrousel glissable
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || drag) return;
    var el = scroller(e.target);
    if (el === hoverEl) return;
    if (hoverEl) hoverEl.classList.remove('pn-draggable');
    hoverEl = el;
    if (el) el.classList.add('pn-draggable');
  });

  function release(el) {
    el.style.scrollSnapType = '';
    el.style.scrollBehavior = '';
    el.classList.remove('pn-dragging');
  }

  function momentum(el, v) {
    function step() {
      if (Math.abs(v) < 0.02) { release(el); return; }
      el.scrollLeft -= v * 16;
      v *= 0.92;
      el._pnRaf = requestAnimationFrame(step);
    }
    el._pnRaf = requestAnimationFrame(step);
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var el = scroller(e.target);
    if (!el) return;
    cancelAnimationFrame(el._pnRaf);
    drag = { el: el, x: e.clientX, left: el.scrollLeft, moved: false, lastX: e.clientX, lastT: performance.now(), v: 0 };
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return;           // un clic court reste un clic
      drag.moved = true;
      drag.el.style.scrollSnapType = 'none';
      drag.el.style.scrollBehavior = 'auto';
      drag.el.classList.add('pn-dragging');
    }
    e.preventDefault();
    drag.el.scrollLeft = drag.left - dx;
    var now = performance.now(), dt = now - drag.lastT;
    if (dt > 0) drag.v = drag.v * 0.6 + ((e.clientX - drag.lastX) / dt) * 0.4;
    drag.lastX = e.clientX; drag.lastT = now;
  });

  function end() {
    if (!drag) return;
    if (drag.moved) {
      justDragged = true;
      setTimeout(function () { justDragged = false; }, 50);
      momentum(drag.el, drag.v);
    }
    drag = null;
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  window.addEventListener('blur', end);

  // apres un glisser, le clic n'ouvre pas la carte
  document.addEventListener('click', function (e) {
    if (justDragged) { e.preventDefault(); e.stopImmediatePropagation(); justDragged = false; }
  }, true);

  // pas de glisser-deposer natif des images/liens dans un carrousel
  document.addEventListener('dragstart', function (e) {
    if (scroller(e.target)) e.preventDefault();
  });

  console.log('[prodnamo] carrousels glissables actifs');
})();
